// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f985dee4","455":"a33d7710","977":"12f087e4"}[chunkId] + ".chunk.js";
};